import {useEffect} from "react";

import {SettingOutlined} from "@ant-design/icons";
import {
	About,
	ContactUsLink,
	CurrentUserAvatar,
	GuideBotButton,
	GuideButton,
	HomeLink,
	initJiraWidgetObserver,
	LogOut,
	openJiraWidgetOrReportError,
	OtherResources,
	ChatbotProvider,
	UIConfigContext,
} from "@digatex/digatex-ui-lib";
import {Layout} from "antd";

import {OTHER_RESOURCES_CONFIG, properties} from "@/properties.js";
import {Logo} from "@/variants/index.js";

import styles from "./Menu.module.css";
import {Link, useNavigate} from "react-router-dom";

export const Menu = ({search}) => {
    const navigate = useNavigate();

    const handleHomeClick = () => {
        navigate("/", { state: { reset: true } });
    };

	useEffect(() => {
		initJiraWidgetObserver();
	}, []);

	function showRequestForm() {
		openJiraWidgetOrReportError({
			moduleName: "Inventory",
		});
	}

	const query = new URLSearchParams(window.location.search);
	const operator = query.get("operator") || "";
	const material = query.get("material") || "";
	const urlParams = {
		operator: operator,
		material: material,
	};

    return (
		<div data-testid="menu-row">
			<Layout.Header className={styles.menu} data-testid="menu-header">
				<nav className={styles.navigation}>
                    <span onClick={handleHomeClick} style={{cursor: 'pointer'}}>
					    <HomeLink data-testid="menu-home-link" image={Logo.image} />
                    </span>
					<Link to="/settings/user-preferences" data-testid="menu-settings-link">
						<SettingOutlined className={styles.settingsIcon} />
					</Link>
					<Link to="/search" state={{reset: true}} data-testid="menu-search-link">
						<img src="/images/magnify-white.png" alt="search" />
					</Link>
				</nav>
				<div className={styles.searchArea}>{search}</div>
				<section className={styles.utilityArea}>
					<About data-testid="menu-about" />
					<UIConfigContext.Provider value={OTHER_RESOURCES_CONFIG}>
						<OtherResources data-testid="menu-other-resources" />
					</UIConfigContext.Provider>
					{properties.chatbotAskOrigin || properties.chatbotAnalyticsOrigin ? (
						<ChatbotProvider moduleName="inventory" urlParams={urlParams}>
							<GuideBotButton />
						</ChatbotProvider>
					) : (
						<GuideButton module="inventory" data-testid="menu-guide" />
					)}
					<ContactUsLink show={showRequestForm} data-testid="menu-contact-us" />
					<LogOut data-testid="menu-logout" />
					<CurrentUserAvatar data-testid="menu-user-avatar" />
				</section>
			</Layout.Header>
		</div>
	);
};
